// src/components/Footer.jsx
import { Link } from "react-router-dom";
import { SITE } from "../data/site";

const FooterLink = ({ to, children }) => (
  <Link className="hover:text-white hover:underline transition" to={to}>
    {children}
  </Link>
);

/* ================= ICONS ================= */
function IconPhone(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.5 3.5l3.2 2.3-1.2 3a14 14 0 006.7 6.7l3-1.2 2.3 3.2-1.4 2.2c-.5.8-1.5 1.2-2.4 1-8.1-1.8-14.6-8.3-16.4-16.4-.2-.9.2-1.9 1-2.4l2.2-1.4z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function IconMail(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4 6h16v12H4V6z" stroke="currentColor" strokeWidth="1.7" />
      <path d="M4 7l8 6 8-6" stroke="currentColor" strokeWidth="1.7" />
    </svg>
  );
}
function IconPin(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 21s7-5.1 7-11a7 7 0 10-14 0c0 5.9 7 11 7 11z"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path d="M12 11.2a2.2 2.2 0 110-4.4 2.2 2.2 0 010 4.4z" fill="currentColor" />
    </svg>
  );
}
function IconWhatsapp(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20.5 11.6a8.5 8.5 0 01-12.5 7.4L4 20l1-3.8A8.5 8.5 0 1120.5 11.6z"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        d="M9.2 8.8c.3-.4.7-.4 1 0l.8 1c.2.2.2.5.1.7l-.3.7c.6 1 1.4 1.8 2.4 2.4l.7-.3c.2-.1.5 0 .7.1l1 .8c.4.3.4.7 0 1-.6.6-1.4.8-2.2.5-2.4-.9-4.3-2.8-5.2-5.2-.3-.8-.1-1.6.5-2.2z"
        fill="currentColor"
        opacity=".9"
      />
    </svg>
  );
}

/* ================= FOOTER ================= */
export default function Footer() {
  const phoneRaw = "+65 8530 3990";
  const tel = "tel:+6585303990";
  const wa = "https://wa.me/6585303990";
  const email = "sales.shade0606@gmail.com";

  return (
    <footer className="mt-0">
      <div className="bg-gradient-to-r from-slate-950 via-slate-900 to-blue-950 text-white border-t border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-14 grid md:grid-cols-3 gap-10">

          {/* Brand */}
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/images/logo.png"
                alt={`${SITE.brand} logo`}
                className="h-18 w-18 rounded-xl bg-white/10 p-1 object-contain"
              />
              <div>
                <div className="font-extrabold text-lg">{SITE.brand}</div>
                <div className="text-xs text-white/70 font-semibold">
                  Shade • Shelter • Roofing • Metal Works
                </div>
              </div>
            </div>

            <p className="text-sm text-white/75 mt-4 leading-relaxed">
              One-stop customized shade, shelter, roofing, metal works and outdoor
              solutions in Singapore. We focus on durable materials, clean finishing
              and reliable installation.
            </p>

            <div className="mt-5 flex flex-wrap gap-2">
              <a
                href={wa}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-extrabold bg-white text-slate-900 hover:bg-slate-100"
              >
                <IconWhatsapp className="h-5 w-5" />
                WhatsApp
              </a>
              <a
                href={tel}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-extrabold border border-white/25 text-white hover:bg-white/10"
              >
                <IconPhone className="h-5 w-5" />
                Call
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div className="font-extrabold">Quick Links</div>
            <ul className="text-sm text-white/75 mt-4 space-y-2">
              <li><FooterLink to="/">Home</FooterLink></li>
              <li><FooterLink to="/services">Services</FooterLink></li>
              <li><FooterLink to="/projects">Projects</FooterLink></li>
              <li><FooterLink to="/contact">Contact</FooterLink></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="font-extrabold">Contact</div>

            <div className="mt-4 space-y-3 text-sm text-white/75">
              <div className="flex gap-2">
                <IconPhone className="h-5 w-5 mt-0.5" />
                <a href={tel} className="hover:underline">{phoneRaw}</a>
              </div>

              <div className="flex gap-2">
                <IconMail className="h-5 w-5 mt-0.5" />
                <a href={`mailto:${email}`} className="hover:underline">
                  {email}
                </a>
              </div>

              <div className="flex gap-2">
                <IconPin className="h-5 w-5 mt-0.5" />
                <div>
                  <div>38, Woodlands Ind Pk E1,</div>
                  <div>#05-13, Singapore 757700</div>
                </div>
              </div>
            </div>

            <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-4">
              <div className="text-xs text-white/70">
                <span className="font-semibold text-white">Working Hours:</span>{" "}
                Mon–Sat (9am–6pm)
              </div>
              <div className="text-xs text-white/60 mt-1">
                For urgent site matters, please WhatsApp us.
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10">
          <div className="max-w-6xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
            <div className="text-xs text-white/60">
              © {new Date().getFullYear()} {SITE.brand}. All rights reserved.
            </div>
            <div className="text-xs text-white/60">
              Built for Singapore • Awnings • Roofing • Zip Track
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
